module.exports = __webpack_public_path__ + "img/point-of-sale.3681304e.webp";